module.exports = __webpack_public_path__ + "img/4.b3372113.jpg";